import type { Address } from "viem"

import { DomainEvent } from "@/domains/events"

export class ManualClPoolCreatedEvent extends DomainEvent {
  static readonly TYPE = "manual-cl-v1.pool-created"
  readonly type = ManualClPoolCreatedEvent.TYPE

  constructor(
    public readonly payload: {
      poolAddress?: Address
      transactionHash?: string
    },
  ) {
    super()
  }
}

export class ManualClPositionCreatedEvent extends DomainEvent {
  static readonly TYPE = "manual-cl-v1.position-created"
  readonly type = ManualClPositionCreatedEvent.TYPE

  constructor(
    public readonly payload: {
      poolAddress: Address
      tokenId?: bigint
      transactionHash?: string
    },
  ) {
    super()
  }
}

/**
 * User added liquidity to an existing position NFT via NFPM.increaseLiquidity.
 */
export class ManualClLiquidityIncreasedEvent extends DomainEvent {
  static readonly TYPE = "manual-cl-v1.liquidity-increased"
  readonly type = ManualClLiquidityIncreasedEvent.TYPE

  constructor(
    public readonly payload: {
      poolAddress: Address
      tokenId: bigint
      transactionHash?: string
    },
  ) {
    super()
  }
}

/**
 * User withdrew some-or-all liquidity from a position via
 * NFPM.decreaseLiquidity. `liquidityRemaining` is what's left on-chain; zero
 * means the position is empty but the NFT still exists.
 */
export class ManualClLiquidityDecreasedEvent extends DomainEvent {
  static readonly TYPE = "manual-cl-v1.liquidity-decreased"
  readonly type = ManualClLiquidityDecreasedEvent.TYPE

  constructor(
    public readonly payload: {
      poolAddress: Address
      tokenId: bigint
      liquidityRemaining?: bigint
      transactionHash?: string
    },
  ) {
    super()
  }
}

/**
 * User collected accrued fees from a position.
 */
export class ManualClFeesCollectedEvent extends DomainEvent {
  static readonly TYPE = "manual-cl-v1.fees-collected"
  readonly type = ManualClFeesCollectedEvent.TYPE

  constructor(
    public readonly payload: {
      poolAddress: Address
      tokenId: bigint
      transactionHash?: string
    },
  ) {
    super()
  }
}

/**
 * User burned a position NFT (multicall: decrease-all + collect + burn).
 */
export class ManualClPositionBurnedEvent extends DomainEvent {
  static readonly TYPE = "manual-cl-v1.position-burned"
  readonly type = ManualClPositionBurnedEvent.TYPE

  constructor(
    public readonly payload: {
      poolAddress: Address
      tokenId: bigint
      transactionHash?: string
    },
  ) {
    super()
  }
}
